export class Auth0ClientConfig {
    public static getAuth0Domain(): string {
        return 'cosmosomni.eu.auth0.com';
    }

    public static getAuth0ClientId(): string {
        switch (window.location.hostname) {
            case 'localhost':
            case 'local.cosmosomni.com':
                return 'LKVtjppsLkjTcSSopVBjy6rYJYTwOYNr';
            case 'test.cosmosomni.com':
                return 'kHXwDVgpZtivo0CLCnkaACK1DPBU3TIU';
            case 'brownie.cosmosomni.com':
            case 'witty-ocean-02f42d003-releasecandidate.westeurope.5.azurestaticapps.net':
                return 'SXHtrskoaSSZVTFY4ONHLghbunia2oA6';
            default:
                return '';
        }
    }

    public static getAuth0RedirectUri(): string {
        let base = window.location.origin + window.location.pathname.replace('index.html', '');
        if (!base.endsWith('/')) {
            base += '/';
        }
        return base + '#/security/bridge';
    }

    // https://test.cosmosomni.com/#/environment/config?environment=sbcosmosdev2&company=BROWNIE.COM&packingStation=prueba&requestWeight=true
}